<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" clearable placeholder="请输入姓名或身份证号"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>
          <a-col :md="10" :sm="24">
            <a-form-item label="注册日期">
              <a-range-picker
                  v-model="time_range_moment"
                  style="width: 100%"
                  format="YYYY-MM-DD"
                  :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
              />
            </a-form-item>
          </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="省市">
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
                />
              </a-form-item>
            </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单位名称">
                <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
              </a-form-item>
            </a-col>


            <a-col :md="6" :sm="24">
              <a-form-item label="考试时间">
                <a-range-picker
                    v-model="time_range_moment"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>

          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >
      <a-button @click="download('', 3)" style="margin-left: 8px">
        监督信息表下载
        <a-icon type="download" />
      </a-button>
    </div>

    <s-table
        ref="table"
        size="default"
        :columns="userColumns"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="name1" slot-scope="text,record">
          <div>
            {{ record.name }}
            <br/>
            <span style="color: #999">{{ record.code }}</span>
            <br/>
            {{ record.num }}
            <br/>
            等级:{{ record.grade }}
          </div>
      </span>
      <span slot="huankao1" slot-scope="text,record">
          <r-switch  :formData="record" field="huankao" @change="setHuankao(record)" :checkedValue="1" :unCheckedValue="2" checkedChildren="缓考" unCheckedChildren="否" />
      </span>
      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{ record.user_name }}
            <br/>
            上传时间 {{ record.create_time|timeFormat }}
            <br/>
            注册时间 {{ record.today|timeFormat }}
          </div>
      </span>
      <span slot="jindu" slot-scope="text,record">
        人数{{ record.membercount }}<br/>
        <a-tag v-if="record.status==1" color="red">等待审核</a-tag>
        <a-tag v-else-if="record.status==2" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.status==3" color="purple">审核失败</a-tag>
        <a-tag v-else>未提交</a-tag>
        <br/>
        <a v-if="record.resultszip && record.resultszip2">成绩已上传</a>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
          <a-divider type="vertical" v-show="record.status==1" />
          <a v-show="record.status==1" @click="download(record, 4)">电子证书</a> 
        </template>
      </span>
    </s-table>


    <a-modal
        :maskClosable="false"
        title="人员操作"
        :width="1000"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="userFormVisible"
        @ok="handleUserFormOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="姓名"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入姓名' }]}
            ]"
                          placeholder="请输入姓名"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="身份证"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'num',
              {rules: [{ required: true, message: '请输入身份证' }]}
            ]"
                          placeholder="请输入身份证"/>
              </a-form-item>
            </a-col>


          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="手机"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'phone',
              {rules: []}
            ]"
                          placeholder="请输入手机"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="性别"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'sex',
              {rules: []}
            ]"
                          placeholder="请输入性别"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="等级"
                  hasFeedback
              >
                <a-select v-model="userFormData.grade" placeholder="请选择"
                          allowClear >
                  <a-select-option value="初级">初级</a-select-option>
                  <a-select-option value="中级">中级</a-select-option>
                  <a-select-option value="高级">高级</a-select-option>
                  <a-select-option value="国家级">国家级</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="注册日期"
                  hasFeedback
              >

                <a-date-picker
                    v-model="userFormData.regist_date_moment"
                    format="YYYY-MM-DD"
                    placeholder="注册日期"/>

              </a-form-item>
            </a-col>


          </a-row>


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="userFormVisible=false">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleUserFormOk">保存</a-button>
      </template>
    </a-modal>
  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import KaoguanPicker from '@/components/KaoguanPicker/'
import JianduPicker from '@/components/JianduPicker/'
import RSwitch from '@/components/RSwitch/'
import areaOptions from '@/utils/area'
import moment from 'moment'
import qs from 'qs'
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

import {getApplyMemberList, memberDetail, memberDelete, memberEdit} from '@/api/jiandu'
import setting from "@/config/setting";

export default {
  name: 'JianduMemberList',
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    EditableCell,
    KaoguanPicker,
    JianduPicker,
    RSwitch
  },
  data() {
    return {
      areaOptions,
      userFormVisible: false,
      kaoguanPickerShow: false,
      jianduPickerShow: false,
      userVisible: false,
      visible: false,
      saveLoading: false,
      formData: {
        id: 0,
        danwei: '',
        datetitle_moment: null,
        datetitle: '',
        resultszip: [],
        kaoguan: [],
        jiandu: [],
        namekeys: [],
        areas: [],
      },
      time_range_moment: [],
      time_range: [],
      labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
        xs: {span: 24},
        sm: {span: 8},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '单位信息',
          dataIndex: 'danwei',
          scopedSlots: {customRender: 'danwei'},
        },
        {
          title: '状态',
          dataIndex: 'jindu',
          scopedSlots: {customRender: 'jindu'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: {customRender: 'action'},
        }
      ],


      //领取人员表头
      userColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '100px'
        },
        {
          title: '人员信息',
          dataIndex: 'name',
          width: '150px',
          scopedSlots: {
            customRender: 'name1',
          }
        },
        // {
        //   title: '身份证',
        //   dataIndex: 'num'
        // },
        // {
        //   title: '等级',
        //   width: '100px',
        //   dataIndex: 'grade',
        // },
        // {
        //   title: '价格',
        //   width: '100px',
        //   dataIndex: 'price',
        // },
        // {
        //   title: '缓考',
        //   width: '100px',
        //   scopedSlots: {
        //     customRender: 'huankao1',
        //   }
        // },
        {
          title: '注册时间',
          width: '150px',
          dataIndex: 'regist_date',
          customRender: (text) => {
            return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss');
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: {
            customRender: 'action',
          }
        },
      ],
      userPagination: {},
      userQuery: {
        manageid: 0,
        status: 0,
        page: 1,
        keywords: undefined
      },
      userFormData: {
        id: 0,
        pic: []
      },
      kaojiUserList: [],


      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        let that = this;

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range = []
        }

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getApplyMemberList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
      },

      selectedRowKeys: [],
      selectedRows: [],
      cashFormData: {
        ids: [],
        to_type: '',
        price: 0,
        note: '',
        count: 0,
      }
    }
  },
  computed: {},
  created() {
  },

  mounted() {
    let that = this;
  },
  methods: {
    moment,
    handleCancel() {
      this.visible = false
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleEdit(record) {
      let self = this
      this.userFormVisible = true
      memberDetail({id: record.id}).then(res => {
        setTimeout(() => {
          res.data.regist_date_moment = moment(res.data.regist_date*1000);
          self.form.setFieldsValue({...res.data})
          self.userFormData.id = record.id;
          self.userFormData = {...res.data};
        }, 200)
      })
      // console.log(this.mdl)
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },
    deleteHandle(record) {
      let self = this
      memberDelete({id: record.id}).then(res => {
        self.$refs.table.refresh(false)
      })
    },
    // 增改 处理
    handleUserFormOk(e) {
      let self = this;
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.userFormData)
          self.saveLoading = true;
          memberEdit({
            id:self.userFormData.id,
            name:values.name,
            num:values.num,
            sex:values.sex,
            phone:values.phone,
            grade:self.userFormData.grade,
            regist_date:self.userFormData.regist_date_moment.format('YYYY-MM-DD')
          }).then(res => {
            self.$message.success('修改成功')
            self.$refs.table.refresh(false)
            self.userFormVisible = false;
            self.saveLoading = false;
          }).catch(err =>{
            self.$message.error(err.data.msg);
            self.saveLoading = false;
          })

        }
      })
    },

    handleUserFormCancel() {
      this.userFormVisible = false
    },

    userSearch(selectedKeys, confirm) {
      let self = this
      confirm();
      self.fetchUserList();
    },
    userSearchReset(selectedKeys, confirm) {
      let self = this;
      confirm();
      self.userQuery.keywords = undefined;
      self.fetchUserList();
    },
    handleUserTableChange(pagination, filters, sorter) {
      console.log('filters', filters);
      let that = this;
      if (filters.grade) {
        that.userQuery.grade = filters.grade[0];
      } else {
        that.userQuery.grade = '';
      }
      const pager = {...this.pagination};
      pager.current = pagination.current;
      that.pagination = pager;
      that.userQuery.page = pagination.current;
      that.fetchUserList();
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    download(record, type) {
      switch (type) {
        case 1:
          window.open(setting.apiBaseURL + '/adminapi/kaojiexame/downloadCertP?id=' + record.qcxj_exame_id);
          break;
        case 2 :
          window.open(setting.apiBaseURL + '/adminapi/kaojiexame/downloadCert?id=' + record.qcxj_exame_id);
          break;
        case 3:
          window.open(setting.apiBaseURL + '/adminapi/qcxj/jiandumemberdownload?' + qs.stringify(this.queryParam));
          break;
        case 4:
          console.log('download',type)
          window.open(setting.apiBaseURL + '/adminapi/jiandu/membercertDownload?id=' + record.id);
          break;
      }
    }

  },
  filters: {},
  watch: {}
}
</script>


<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
